const checks = [
  { label: 'Deal properties', value: '664', detail: 'Schema fields returned' },
  { label: 'Company properties', value: '295', detail: 'Schema fields returned' },
  { label: 'Contact properties', value: '506', detail: 'Schema fields returned' },
  { label: 'Deal pipelines', value: '12', detail: 'Pipeline definitions returned' },
];

const capabilities = [
  ['Current deal properties', 'Observed', 'Core fields were present in the checked schema: pipeline, stage, amount, currency, created/closed dates, owner ID, and last-modified date.'],
  ['Deal stage history', 'Observed', 'A bounded read found stage history for a sample deal.'],
  ['Pipeline and amount history', 'Observed', 'A bounded read found pipeline, amount, and close-date history fields.'],
  ['Company and contact links', 'Observed', 'Association labels and a bounded deal association read responded.'],
];

export default function Growth() {
  return (
    <div className="growth-page">
      <div className="growth-heading">
        <div>
          <div className="growth-eyebrow">GROWTH · HUBSPOT</div>
          <h1>Growth data connection</h1>
          <p className="growth-sub">Read-only HubSpot metadata snapshot</p>
        </div>
        <span className="tag">Snapshot · checked October 19, 2026</span>
      </div>

      <div className="growth-callout">
        <b>Snapshot checked October 19, 2026.</b> This page shows source metadata and connection capabilities observed during that check; it does not report current HubSpot availability. No CRM names, deal values, or identifiers are displayed. One sample deal was read in memory to test history and associations, then discarded.
      </div>

      <div className="growth-stats">
        {checks.map((item) => <article className="growth-stat" key={item.label}>
          <div className="growth-stat-label">{item.label}</div>
          <div className="growth-stat-value">{item.value}</div>
          <div className="growth-stat-detail">{item.detail}</div>
        </article>)}
      </div>

      <section className="growth-panel">
        <div className="growth-panel-head"><h2>Fields observed in the check</h2><span className="tag">HubSpot API version · 2026-09</span></div>
        <div className="growth-capabilities">
          {capabilities.map(([label, status, detail]) => <div className="growth-capability" key={label}>
            <div><b>{label}</b><p>{detail}</p></div>
            <span className="growth-status">{status}</span>
          </div>)}
        </div>
      </section>

      <section className="growth-panel">
        <div className="growth-panel-head"><h2>Growth reports</h2><span className="tag">Not reporting yet</span></div>
        <div className="growth-not-ready">
          <div className="growth-lock">↗</div>
          <div><b>Report data is not loaded.</b>
            <p>Before we publish pipeline, win-rate, cycle-time, or reconciliation figures, the team still needs to confirm the selected pipelines and business field mappings, verify coverage for both HubSpot instances, and complete the approved read-only warehouse path in <a href="https://github.com/dispel/dispel-finance-app/issues/274">issue #274</a>.</p>
          </div>
        </div>
        <div className="growth-footnote">Snapshot checked October 19, 2026 · metadata probe and one-record capability sample · source grants, full account coverage, history completeness, and recurring refresh are not verified. Scheduled refresh, dashboard alerts, and manual refresh are tracked in <a href="https://github.com/dispel/dispel-finance-app/issues/275">issue #275</a>.</div>
      </section>
    </div>
  );
}
